import { createAction } from '@reduxjs/toolkit';

// Added to avoid cyclic dependency to userSlice
export const setHasUserInsufficientPermissions = createAction<boolean>('user/setHasUserInsufficientPermissions');
